import { useState, useContext, useEffect, useCallback } from "react";
import { AuthContext } from "../context/AuthContext";

const useVote = (post, updatePosts) => {
  if (!post) {
    throw new Error("Post is required for useVote hook");
  }

  const [upvotes, setUpvotes] = useState(post.upvotes);
  const [downvotes, setDownvotes] = useState(post.downvotes);
  const { isLoggedIn, setIsLoggedIn, user, setUser } = useContext(AuthContext);
  const [isVoting, setIsVoting] = useState(false);

  const handleVote = useCallback(
    async (comment, type) => {
      if (!user) {
        console.error("User is not logged in");
        return;
      }

      if (isVoting) return; // Prevent multiple requests
      setIsVoting(true);

      try {
        const voteData = {
          userId: user.id,
          postId: post.postId,
          voteType: type,
        };
        const response = await fetch(
          `${process.env.REACT_APP_SC_API_BASE_URL}/api/votes/votePost`,
          {
            method: "POST",
            headers: {
              accept: "*/*",
              Authorization: `Bearer ${user.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(voteData),
          }
        );

        if (response.ok) {
          const data = await response.json();
          setUpvotes(data.upvotes);
          setDownvotes(data.downvotes);
          updatePosts(post.postId, data.upvotes, data.downvotes);
        } else {
          console.error("Failed to vote");
        }
      } catch (error) {
        console.error("Error voting:", error);
      } finally {
        setIsVoting(false);
      }
    },
    [post.postId, updatePosts, isVoting, user]
  );

  return { handleVote, upvotes, downvotes };
};

export default useVote;
